import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResponse } from '@app/models';
import { MyFeedback } from '../_models/my-feedback';
import { BaseServiceClass } from './baseService.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MyFeedbackService extends BaseServiceClass<MyFeedback> {
  constructor(protected http: HttpClient) {
    super(http, '/api/v2/agent-summary/my-feedbacks');
  }

  public filterMyFeedbacks(filters: any): Observable<PageResponse<MyFeedback>> {
    return this.http.get<PageResponse<MyFeedback>>(`${this.entity_url}`, { params: filters });
  }

  public acknowledgeFeedback(id: number): Observable<MyFeedback> {
    return this.http.put<MyFeedback>(`${environment.apiUrl}/api/v2/agent-summary/${id}/acknowledge`, {});
  }
}
